import React from "react";

export function LoadingConnection(): JSX.Element {
  return (
    <a className="stripe-connect light-blue" href="#" onClick={() => false}>
      <span>Loading Stripe</span>
    </a>
  );
}
